import i18next from "src/i18n/config";
import RouteService from "src/services/routeService";
import { transformErrorResponse } from "src/store/helpers";
import { PaginatedResponse } from "src/types";

import { toBackendPageIndex } from "@shared/table/Tanstack.utils";

import { AdminBuilder } from "./tags";

export type GetFdroidReposParams = {
    workspaceId?: number;
    name?: string;
    title?: string;
    url?: string;
    pageIndex?: number;
    pageSize?: number;
    sortCriteria?: string;
    sortDirection?: 0 | 1;
};

const fdroid = (builder: AdminBuilder) => ({
    getFdroidRepos: builder.query<PaginatedResponse<API.FdroidRepoAdmin>, GetFdroidReposParams>({
        providesTags: ["FdroidRepos"],
        transformErrorResponse: (err) => transformErrorResponse(err, i18next.t("common:error.technicalDifficulties.message")),
        query: async (payload) => {
            const base = await RouteService.getFdroidReposRoute();
            return {
                url: `${base}all`,
                params: { ...payload, pageIndex: toBackendPageIndex(payload.pageIndex) },
            };
        },
    }),
});

export default fdroid;
